import { reportType } from '../../constants/reportType';
import aggregationHelper from '../functions/aggregation/aggregationHelper';
import assignmentHelper from '../functions/assignment/assignmentHelper';
import dataSourceHelper from '../functions/common/dataSourceHelper';
import Declaration from '../../types/Functions/Declaration';
import IngestionConfig from '../../../types/ingestion/IngestionConfig';
import Operand from '../../../types/functions/Operand/Operand';
import ReportConfig from '../../../types/report/ReportConfig';

const fix = (declaration: Declaration, isBespoke: boolean): void => {

    declaration.errors = [];

    if (isBespoke) {
        return;
    }

    assignmentHelper.asCollection(declaration.assignment).forEach(a => {

        if (a.doNotPopulate) {
            a.value = {} as Operand;
        }
    });
};

const prepare = (config: ReportConfig, dataSources: IngestionConfig[]): void => {

    addNewComponentsIfAny(config);

    if (config.type === reportType.accuracy || config.type === reportType.globalModule) {

        config.rawDataSourceId = null;
    }


    if (config.type === reportType.globalModule) {
        config.lookups.forEach(x => x.errors = []);
        config.variables.forEach(x => x.errors = []);
        config.userDefinedFunctions.forEach(d => {

            d.errors = [];
            d.parameters.forEach(p => { p.errors = [] });
        });
    }

    if (config.type !== reportType.globalModule) {

        resetErrors(config);

        config.aggregations.forEach(a => {

            a.errors = [];

            let dataSource = dataSourceHelper.getById(dataSources, a.dataSourceId);

            aggregationHelper.syncFields(a, dataSource);

            a.fields.forEach(f => fix(f, false));
        });

        config.cases.forEach(c => {

            c.errors = [];
            c.fields.forEach(f => fix(f, f.isBespoke));
        });

        config.dictionaries.forEach(d => {

            d.errors = [];
            d.fields.forEach(f => { f.errors = [] });
        });
    }

    config.lookups.forEach(l => {

        l.errors = [];

        if (l.isEndpoint) {

            l.dataSource1Id = null;
        }
    });
};


const getEmptyReportConfigCollections = (type?: string): any => {
    return {
        matchingKey: {},
        matchingKeyEndPoint: {},
        isinSelectors: [],
        leiSelectors: [],
        exchangeRatesSelectors: [],
        annaDsbUpiEnrichmentSelectors: [],
        annaDsbUpiSelectors: [],
        symbolSelectors: [],
        lseSelectors: [],
        firdsFcaInstrumentSelectors: [],
        firdsEsmaInstrumentSelectors: [],
        fcaRegulatedEntitiesSelectors: [],
        userDefinedFunctions: [],
        lookups: [],
        dictionaries: [],
        variables: [],
        aggregations: [],
        filters: [],
        endpointFilters: [],
        cases: []
    };
};

const addNewComponentsIfAny = (config: any): void => {
    let emptyConfig = getEmptyReportConfigCollections();

    for (const key in emptyConfig) {
        if (!config.hasOwnProperty(key)) {
            config[key]=Array.isArray(emptyConfig[key])?[]:{};
        }
    }
}

const resetErrors = (config: ReportConfig): void => {
    config.isinSelectors.forEach(x => x.errors = []);
    config.leiSelectors.forEach(x => x.errors = []);
    config.exchangeRatesSelectors.forEach(x => x.errors = []);
    config.annaDsbUpiEnrichmentSelectors.forEach(x => x.errors = []);
    config.lseSelectors.forEach(x => x.errors = []);
    config.symbolSelectors.forEach(x => x.errors = []);
    config.firdsFcaInstrumentSelectors.forEach(x => x.errors = []);
    config.firdsEsmaInstrumentSelectors.forEach(x => x.errors = []);
    config.annaDsbUpiSelectors.forEach(x => x.errors = []);
    config.fcaRegulatedEntitiesSelectors.forEach(x => x.errors = []);
    config.validations.forEach(x => x.errors = []);
    config.filters.forEach(x => x.errors = []);
    config.endpointFilters.forEach(x => x.errors = []);
    config.matchingKey.errors = [];
    config.matchingKeyEndPoint.errors = [];
    config.lookups.forEach(x => x.errors = []);
    config.variables.forEach(x => x.errors = []);

    config.userDefinedFunctions.forEach(d => {

        d.errors = [];
        d.parameters.forEach(p => { p.errors = [] });
    });
}

const isValidationConfig = (reportConfig: ReportConfig) => {
    const reportConfigTypes = ['Accuracy', 'AccuracyCore'];
    return reportConfigTypes.includes(reportConfig.type);
}

const editReportConfigHelper = {
    prepare,
    isValidationConfig,
    resetErrors
};

export default editReportConfigHelper;
